module.exports = __webpack_public_path__ + "static/media/back-icon.af2907d8.svg";